<form id="login" [formGroup]="form" (ngSubmit)="onSubmit()">
  <input title="Form input"
    class="form-control"
    formControlName="email"
    type="email"
    placeholder="Email"
    autocomplete="off"
  />

  @if (email && email.invalid && email.dirty) {
    <div class="error-message">You must enter a valid email address</div>
  }

  @if (serverMessage) {
    <div class="server-error">{{ serverMessage }}</div>
  }

  @if (successMessage) {
    <div class="success-message">{{ successMessage }}</div>
  }

  <button
    class="btn btn-primary btn-fill btn-danger"
    type="submit"
    [disabled]="form.invalid || loading"
  >
    @if (loading) {
      Sending...
    } @else {
      Send Reset Email
    }
  </button>
  <a class="btn btn-primary btn-sm btn-fill" routerLink="/login"
    >Back To Login</a
  >
</form>
